import { Box, BoxProps } from "@chakra-ui/react";
import React from "react";
import { useTableBoxContext } from "shared/components/table/box/TableBoxContext";

export const TableBoxBody: React.FC<React.PropsWithChildren<BoxProps>> = ({
  children,
  sx,
  ...props
}) => {
  const { isFullHeight, isFullScreen } = useTableBoxContext();
  return (
    <Box
      className="mb-tablebox-body"
      sx={{
        ...sx,
        width: "100%",
        ...(isFullHeight || isFullScreen
          ? {
              flex: 1,
              minHeight: 0,
              overflow: "hidden",
              display: "flex",
              flexDirection: "row",
              height: "100%",
            }
          : undefined),
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
